export class ProjectBudget {
  public acquisition: number;
  public hardCost: number;
  public softCost: number;
  public financing: number;
  public totalCosts: number;
  public totalCostsPerGrossAreaUnit: number;
  public totalCostsPerNetAreaUnit: number;
  public hasValue: boolean;
}
